var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap mt-2"},[_c('div',{staticClass:"main-table custom-table facility-table branch-table"},[_c('data-table',{attrs:{"data-source":_vm.branchList,"grid-columns":_vm.gridColumns,"init-grid":_vm.initializeGrid,"rowFocus":1,"showFocus":false,"allowAddNew":false,"isShowToolbar":false,"isReadOnly":_vm.isReadOnly}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }